import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "app/apps/queryClient";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppointmentCreatedPage from "../../../../pages/status/post-checkout-appointment/appointment-created";
import CustomToastContainer from "../../../../shared/ui/custom-toast-container";
import CartProvider from "../../../providers/CartProvider";
import OrderProvider from "../../../providers/OrderProvider";
import { AppProps } from "../../BaseApp";

const App: React.FC<AppProps> = (props, context) => {
  const getBasename = (): string => {
    return props.configuration.basename || "afspraak-bedankt/";
  };

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <CartProvider>
          <OrderProvider>
            <CustomToastContainer />
            <Routes>
              <Route
                path={getBasename()}
                element={<AppointmentCreatedPage />}
              />
            </Routes>
          </OrderProvider>
        </CartProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
